import { faArrowsRotate, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { UploadOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { updateAdapterRefreshTable } from "../../../redux/adapters/adapterSlice";
import { Permission, hasPermission } from "../../../utils/validatePermissions";
// INTERFACES
import { RootState } from "../../../app/store";
// WIZARD COMPONENTS
import WizardImportDialog from "../../setupWizard/components/WizardImportDialog";

const HEADER_BUTTON_STYLE: React.CSSProperties = {
  minWidth: 170,
  height: 40,
};

function AdaptersHeader() {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */

  // ************************************************ */
  // USE STATE VARIABLES **************************** */
  const [importOpen, setImportOpen] = useState(false);

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */
  // LOCAL STORAGE AND VARIABLES ******************** */
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { permissionSet } = useSelector((state: RootState) => state.user);
  const { globalOrganizationId } = useSelector((state: RootState) => state.home);
  const [t] = useTranslation("global");

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */
  const handleNavigateCreateAdapter = () => {
    navigate({ pathname: "/edge-management/adapters/create" });
  };
  const handleReloadPage = () => {
    dispatch(updateAdapterRefreshTable(true));
    setTimeout(() => {
      dispatch(updateAdapterRefreshTable(false));
    }, 1000);
  };
  const handleImportSuccess = () => {
    handleReloadPage();
  };

  // ************************************************* */
  // USE EFFECT ************************************** */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div>
      <div className="generalStyles__pageHeader">
        {hasPermission(Permission.AdaptersCreate, permissionSet ?? []) && (
          <div className="generalStyles__mlFix mt-1">
            <Button
              className="buttonStyle__1"
              icon={<FontAwesomeIcon icon={faPlus} className="generalStyles__mrFix" />}
              onClick={handleNavigateCreateAdapter}
              style={HEADER_BUTTON_STYLE}
            >
              {t("adapter.createNewAdapter")}
            </Button>
          </div>
        )}
        {hasPermission(Permission.AdaptersView, permissionSet ?? []) && (
          <div className="generalStyles__mlFix mt-1">
            <Button
              className="buttonStyle__8"
              icon={<FontAwesomeIcon icon={faArrowsRotate} className="generalStyles__mrFix" />}
              onClick={() => {
                handleReloadPage();
              }}
              style={HEADER_BUTTON_STYLE}
            >
              {t("userManagement.refreshTable")}
            </Button>
          </div>
        )}
        {hasPermission(Permission.AdaptersView, permissionSet ?? []) && (
          <div className="generalStyles__mlFix mt-1">
            <Button
              icon={<UploadOutlined />}
              onClick={() => setImportOpen(true)}
              disabled={!globalOrganizationId}
              style={HEADER_BUTTON_STYLE}
            >
              Import
            </Button>
          </div>
        )}
      </div>
      {globalOrganizationId && (
        <WizardImportDialog
          orgId={globalOrganizationId}
          visible={importOpen}
          onClose={() => setImportOpen(false)}
          onSuccess={handleImportSuccess}
        />
      )}
    </div>
  );
}

export default AdaptersHeader;
